import { twMerge } from 'utilities/src/twMerge';
import * as React from 'react';

import GenericIconProps from '../_icon.type';

export default function ChevronRight({ className = '', viewBox = '0 0 24 24', size }: GenericIconProps) {
  return (
    <svg
      className={twMerge(className, size)}
      viewBox={viewBox}
      width="24"
      height="24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.70504 6L8.29504 7.41L12.875 12L8.29504 16.59L9.70504 18L15.705 12L9.70504 6Z" />
    </svg>
  );
}
